// CLEAN KEYS FALSE
const cleanFalseKeys = (obj) => {
  const newObj = {};
  Object.entries(obj).forEach(([key, val]) => {
    if (val) {
      newObj[key] = val;
    }
  });
  return newObj;
};

export { cleanFalseKeys };
